module.exports = __webpack_public_path__ + "img/1970East-034_WEB-min.eb8a4571.jpg";